import { useCallback, useRef } from "react";

/** Returns a generator producing stable, monotonically increasing ids of the form `${prefix}-${n}`. */
export const useIncrementingId = (prefix: string): (() => string) => {
  const counterRef = useRef(0);
  return useCallback(() => {
    counterRef.current += 1;
    return `${prefix}-${counterRef.current}`;
  }, [prefix]);
};
